import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { Route, Router } from '@angular/router';
import { authGuard } from './auth/guards/is-authenticated.guard';
import { AuthStore } from './stores/auth';

export const CAN_MATCH_NEW_THEME = () => {
  const user = inject(AuthStore).user();
  if (user) {
    return user.company?.web_theme === 'wt2024_new';
  }

  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return false;
  }

  // Fallback for refresh/initial load
  return localStorage.getItem('company_web_theme') === 'wt2024_new';
};

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./homepage/home-page.component').then((m) => m.HomePageComponent),
  },
  {
    path: 'payment',
    data: { reuse: false },
    loadChildren: () => import('./payment').then((m) => m.PaymentModule),
  },
  {
    path: 'proof',
    loadChildren: () => import('./proof').then((m) => m.ProofModule),
  },
  {
    path: 'auth',
    data: { reuse: false },
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    data: { reuse: false, isLogging: true },
    loadChildren: () => import('./auth').then((m) => m.AuthModule),
  },
  //B2B
  {
    path: 'categoryB2B/:alias',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./catelogue B2B').then((m) => m.CatelogueComponent),
  },

  {
    path: 'productB2B',
    data: { reuse: false },
    canActivate: [authGuard],
    loadChildren: () => import('./product B2B').then((m) => m.ProductModule),
  },
  {
    path: 'dashboard',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./homepage/dashboard B2B').then((m) => m.DashboardComponent),
  },
  {
    path: 'dashboard/',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./homepage/dashboard B2B').then((m) => m.DashboardComponent),
  },
  {
    path: 'collection',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./myCollection').then((m) => m.CollectionComponent),
  },
  {
    path: 'collection/',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./myCollection').then((m) => m.CollectionComponent),
  },
  {
    path: 'account-information',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/account-information').then(
        (m) => m.AccountInfoComponent,
      ),
  },
  {
    path: 'account-information/',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/account-information').then(
        (m) => m.AccountInfoComponent,
      ),
  },
  {
    path: 'resources/mockUp',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/mockUp').then((m) => m.MockUpComponent),
  },
  {
    path: 'resources/inventory-report',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/inventory-report').then(
        (m) => m.inventoryReportComponent,
      ),
  },
  {
    path: 'resources/order-report',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/order-report').then((m) => m.OrderReportComponent),
  },
  {
    path: 'resources/storeProfile',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/storeProfile').then((m) => m.storeProfileComponent),
  },
  {
    path: 'resources/manage-profile',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/manage-profile').then(
        (m) => m.manageProfileComponent,
      ),
  },
  {
    path: 'resources/campaign-excel',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/campaign-excel').then(
        (m) => m.CampaignExcelComponent,
      ),
  },
  {
    path: 'resources/campaign-budget',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/campaign-budget').then(
        (m) => m.CampaignBudgetComponent,
      ),
  },
  {
    path: 'campaign/status',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/campaign-status').then(
        (m) => m.CampaignStatusComponent,
      ),
  },
  {
    path: 'resources/campaign-status',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/campaign-status').then(
        (m) => m.CampaignStatusComponent,
      ),
  },
  {
    path: 'resources/distroListFE',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/distroListFE').then((m) => m.DistroListFEComponent),
  },
  {
    path: 'resources/shipment-tracking',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/shipment-tracking').then(
        (m) => m.ShipmentTrackingComponent,
      ),
  },

  //B2C
  {
    path: 'checkout/:alias',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () => import('./checkout').then((m) => m.CheckoutComponent),
  },
  {
    path: 'checkout/:alias/',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () => import('./checkout').then((m) => m.CheckoutComponent),
  },
  {
    path: 'landingpage',
    canMatch: [CAN_MATCH_NEW_THEME],
    canActivate: [authGuard],
    loadComponent: () =>
      import('./homepage/landing-page B2C New').then(
        (m) => m.LandingPageNewComponent,
      ),
  },
  {
    path: 'landingpage',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./homepage/landing-page').then((m) => m.LandingPageComponent),
  },
  {
    path: 'landingpage/',
    canMatch: [CAN_MATCH_NEW_THEME],
    canActivate: [authGuard],
    loadComponent: () =>
      import('./homepage/landing-page B2C New').then(
        (m) => m.LandingPageNewComponent,
      ),
  },
  {
    path: 'landingpage/',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./homepage/landing-page').then((m) => m.LandingPageComponent),
  },
  {
    path: 'category/:parent/:child',
    canMatch: [CAN_MATCH_NEW_THEME],
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./catelogue B2C New').then((m) => m.CatelogueNewComponent),
  },
  {
    path: 'category/:parent/:child',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./catelogue').then((m) => m.CatelogueComponent),
  },
  {
    path: 'category/:parent/:child/',
    canMatch: [CAN_MATCH_NEW_THEME],
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./catelogue B2C New').then((m) => m.CatelogueNewComponent),
  },
  {
    path: 'category/:parent/:child/',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./catelogue').then((m) => m.CatelogueComponent),
  },
  {
    path: 'category/:alias',
    canMatch: [CAN_MATCH_NEW_THEME],
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./catelogue B2C New').then((m) => m.CatelogueNewComponent),
  },
  {
    path: 'category/:alias',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./catelogue').then((m) => m.CatelogueComponent),
  },
  {
    path: 'category/:alias/',
    canMatch: [CAN_MATCH_NEW_THEME],
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./catelogue B2C New').then((m) => m.CatelogueNewComponent),
  },
  {
    path: 'category/:alias/',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./catelogue').then((m) => m.CatelogueComponent),
  },
  // Blog (B2C New only). No canMatch: the theme isn't known yet on reload,
  // so the gate waits for it and shows not-found for other themes.
  {
    path: 'blog',
    pathMatch: 'full',
    data: { reuse: false, blogPage: 'list' },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./blog B2C New').then((m) => m.BlogThemeGateComponent),
  },
  {
    path: 'blog/',
    pathMatch: 'full',
    data: { reuse: false, blogPage: 'list' },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./blog B2C New').then((m) => m.BlogThemeGateComponent),
  },
  {
    path: 'blog/:alias',
    pathMatch: 'full',
    data: { reuse: false, blogPage: 'detail' },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./blog B2C New').then((m) => m.BlogThemeGateComponent),
  },
  {
    path: 'blog/:alias/',
    pathMatch: 'full',
    data: { reuse: false, blogPage: 'detail' },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./blog B2C New').then((m) => m.BlogThemeGateComponent),
  },
  {
    path: 'quotation',
    data: { reuse: false },
    canActivate: [authGuard],
    loadChildren: () => import('./quotation').then((m) => m.QuotationModule),
  },
  {
    path: 'orders',
    canMatch: [CAN_MATCH_NEW_THEME],
    data: { reuse: false },
    canActivate: [authGuard],
    loadChildren: () =>
      import('./orders B2C New').then((m) => m.OrderNewModule),
  },
  {
    path: 'orders',
    data: { reuse: false },
    canActivate: [authGuard],
    loadChildren: () => import('./orders').then((m) => m.OrderModule),
  },
  {
    path: 'order',
    data: { reuse: false },
    canActivate: [authGuard],
    loadChildren: () => import('./orders-b2b').then((m) => m.OrderB2BModule),
  },
  // shared
  {
    path: 'product',
    canMatch: [CAN_MATCH_NEW_THEME],
    data: { reuse: false },
    // Public route - no authGuard needed
    loadChildren: () =>
      import('./product B2C New').then((m) => m.ProductNewModule),
  },
  {
    path: 'product',
    data: { reuse: false },
    // Public route - no authGuard needed
    loadChildren: () => import('./product').then((m) => m.ProductModule),
  },
  {
    path: 'product/',
    canMatch: [CAN_MATCH_NEW_THEME],
    data: { reuse: false },
    // Public route - no authGuard needed
    loadChildren: () =>
      import('./product B2C New').then((m) => m.ProductNewModule),
  },
  {
    path: 'product/',
    data: { reuse: false },
    // Public route - no authGuard needed
    loadChildren: () => import('./product').then((m) => m.ProductModule),
  },
  {
    path: 'events/reset-password/:token',
    pathMatch: 'full',
    loadComponent: () =>
      import('./events/reset-password').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'events/reset-password/:token/',
    pathMatch: 'full',
    loadComponent: () =>
      import('./events/reset-password').then((m) => m.ResetPasswordComponent),
  },
  // static page
  {
    path: 'resources/accountInfo',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/account-information').then(
        (m) => m.AccountInfoComponent,
      ),
  },
  {
    path: 'resources/accountInfo/',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/account-information').then(
        (m) => m.AccountInfoComponent,
      ),
  },
  {
    path: 'resources/register',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/register').then((m) => m.RegisterComponent),
  },
  {
    path: 'resources/register/',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/register').then((m) => m.RegisterComponent),
  },
  {
    path: 'resources/how-to-order',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/howToOrder').then((m) => m.HowToOrderComponent),
  },
  {
    path: 'resources/how-to-order/',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/howToOrder').then((m) => m.HowToOrderComponent),
  },
  {
    path: 'resources/about-us',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/about-us').then((m) => m.AboutUsComponent),
  },
  {
    path: 'resources/about-us/',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/about-us').then((m) => m.AboutUsComponent),
  },
  {
    path: 'resources/promotions',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/promotions/promotions.component').then(
        (m) => m.PromotionsComponent,
      ),
  },
  {
    path: 'resources/promotions/',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./resources/promotions/promotions.component').then(
        (m) => m.PromotionsComponent,
      ),
  },
  {
    path: 'resources/shipping',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/shipping').then((m) => m.ShippingComponent),
  },
  {
    path: 'resources/shipping/',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/shipping').then((m) => m.ShippingComponent),
  },
  {
    path: 'resources/terms-and-conditions',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/terms-and-conditions').then(
        (m) => m.TermsAndConditionsComponent,
      ),
  },
  {
    path: 'resources/terms-and-conditions/',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/terms-and-conditions').then(
        (m) => m.TermsAndConditionsComponent,
      ),
  },
  {
    path: 'resources/privacy-policy',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/privacy-policy').then(
        (m) => m.PrivacyPolicyComponent,
      ),
  },
  {
    path: 'resources/privacy-policy/',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/privacy-policy').then(
        (m) => m.PrivacyPolicyComponent,
      ),
  },
  {
    path: 'resources/contact-us',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/contact-us').then((m) => m.ContactUsComponent),
  },
  {
    path: 'resources/contact-us/',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/contact-us').then((m) => m.ContactUsComponent),
  },
  {
    path: 'resources/faqs',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/faqs').then((m) => m.FaqsComponent),
  },
  {
    path: 'resources/faqs/',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./resources/faqs').then((m) => m.FaqsComponent),
  },
  {
    path: 'resources/media-management',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./media/management/media.management.component').then(
        (m) => m.MediaManagementComponent,
      ),
  },
  {
    path: 'resources/media-management/',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./media/management/media.management.component').then(
        (m) => m.MediaManagementComponent,
      ),
  },
  {
    path: 'resources/media-management/detail/:file_id',
    canActivate: [authGuard],
    pathMatch: 'full',
    loadComponent: () =>
      import('./media/management/media-detail.management.component').then(
        (m) => m.MediaDetailManagementComponent,
      ),
  },
  {
    path: 'resources/detail/:folder_id_link',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () => import('./media').then((m) => m.MediaComponent),
  },
  {
    path: 'resources/folder/:folder_id_link',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./media/media-list/media-list.component').then(
        (m) => m.MediaListComponent,
      ),
  },
  {
    path: 'resources/folder/:folder_id_link',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./media/media-list/media-list.component').then(
        (m) => m.MediaListComponent,
      ),
  },
  {
    path: 'document/detail/:file_id_link',
    pathMatch: 'full',
    data: { reuse: false },
    canActivate: [authGuard],
    loadComponent: () =>
      import('./media/document-detail/document-detail.component').then(
        (m) => m.DocumentDetailComponent,
      ),
  },
  {
    path: 'internal-review',
    pathMatch: 'full',
    loadComponent: () =>
      import('./internal-review/internal-review.component').then(
        (m) => m.InternalReviewComponent,
      ),
  },
  {
    path: 'internal-review/',
    pathMatch: 'full',
    loadComponent: () =>
      import('./internal-review/internal-review.component').then(
        (m) => m.InternalReviewComponent,
      ),
  },
  {
    path: '**',
    data: { reuse: false },
    loadComponent: () =>
      import('./page-not-found/page-not-found.component').then(
        (m) => m.PageNotFoundComponent,
      ),
  },
];
